import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const ProjectHeader = () => {
  return (
    <header className="py-8" id="header">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          {/* logo */}
          <Link to='/'>
            <img className="w-36 md:w-8/12" src={logo} alt="Portfolio Logo" />
          </Link>
          {/* Button */}
          <Link to="/" smooth={true} spy={true}>
            <button className="btn text-[11px] md:text-base py-1 px-3 md:py-3 md:px-5">Back to Home</button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default ProjectHeader;
